import React, { useState } from 'react';
import ProfilingFilterBar from './ProfilingFilterBar';
import ProfilingFilterBarV2 from './profilingcardsfilter';
import ProfilingCards from './ProfilingCards';
import './profiling.css'; // Assuming you have some CSS file for styling
import { useNavigate } from 'react-router-dom';

const Profiling = () => {
  const [profiles, setProfiles] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [loading, setLoading] = useState(false); // Added loading state
  const handleAddProfile = (newProfile) => {
    const isDuplicate = profiles.some(
      (profile) => profile.platform.toLowerCase() === newProfile.platform.toLowerCase() && profile.username === newProfile.username
    );

    if (isDuplicate) {
      console.log('This profile has already been added.');
    } else {
      setProfiles(prevProfiles => [...prevProfiles, newProfile]);
    }
  };

  const handleFilterChange = ({ searchTerm, selectedPlatforms }) => {
    let filtered = profiles;
  
    if (searchTerm) {
      filtered = filtered.filter(profile => 
        profile.username && profile.username.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  
    if (selectedPlatforms.length > 0) {
      filtered = filtered.filter(profile => 
        profile.platform && selectedPlatforms.includes(profile.platform.toLowerCase())
      );
    }
  
    setFilteredProfiles(filtered);
  };
  
  const navigate = useNavigate();
  const handleViewProfile = (profile) => {
    navigate(`/DetailProfile/${profile.platform}/${profile.username}`, { state: { profile } });
  };

  return (
    <div className="p-main-content">
 
    {/* Profiling Filter Bar (Manual Add Profile) */}
    <ProfilingFilterBar onAddProfile={handleAddProfile} selectedPlatforms={selectedPlatforms} />

    {/* Profiling Filter Bar V2 */}
    <ProfilingFilterBarV2 onFilterChange={handleFilterChange} setSelectedPlatforms={setSelectedPlatforms} selectedPlatforms={selectedPlatforms} />

    {/* Profiling Cards */}
    <ProfilingCards profiles={filteredProfiles.length > 0 ? filteredProfiles : profiles} onViewProfile={handleViewProfile} />
  </div>
  );
};

export default Profiling;
